import React from "react";
import { ColumnType } from "antd/lib/table";
import { CheckboxOptionType } from "antd/es/checkbox";
import { DropdownInput } from "components";
import { EMPTY } from "constants/common";
import { AiccSttOption, AiccSttRole, AiccSttSettingRow } from "types/model/aiccLearningAssets";
import { getSttOptionName, STT_ROLE_NAME } from "./configs";

interface ColumnHandlers {
  isEditing: boolean;
  optionSelectOptions: CheckboxOptionType[];
  /** The catalogue, for turning a stored id into a name. */
  options: AiccSttOption[];
  onOptionChange: (role: AiccSttRole, optionKey: string) => void;
}

const getColumns = ({
  isEditing,
  optionSelectOptions,
  options,
  onOptionChange,
}: ColumnHandlers): ColumnType<AiccSttSettingRow>[] => [
  {
    title: "Setting",
    dataIndex: "id",
    key: "id",
    width: 320,
    render: (id: AiccSttRole) => STT_ROLE_NAME[id],
  },
  {
    title: "Option",
    dataIndex: "optionKey",
    key: "optionKey",
    width: 320,
    render: (optionKey: string | undefined, row) =>
      isEditing ? (
        <DropdownInput
          options={optionSelectOptions}
          value={optionKey}
          placeholder="Option"
          mode="single"
          onChange={(value: string) => onOptionChange(row.id, value)}
        />
      ) : (
        getSttOptionName(options, optionKey) || EMPTY
      ),
  },
];

export default getColumns;
